import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { extractUtmSearch } from '../../../utils/analytics/extractUtmSearch';
import { sendGA4PageView } from '../../../utils/analytics/ga4';

// Query params on this app can contain PII (verification tokens, reset-
// password codes, email addresses on flow URLs) that must not reach GA.
// We forward ONLY the standard UTM attribution keys explicitly. Everything
// else is stripped. See extractUtmSearch for the allowlist.
export function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    const utmSearch = extractUtmSearch(location.search);
    const page = utmSearch
      ? `${location.pathname}?${utmSearch}`
      : location.pathname;
    sendGA4PageView({ hitType: 'pageview', page });
  }, [location.pathname, location.search]);

  return null;
}
